import React, { useState, useContext } from "react";
import { Row, Col, Button, Modal, Dropdown, ListGroup } from "react-bootstrap";
import renderHTML from "react-render-html";
import EditDocument from "./EditDocument";
import Context from "../Context";
import { CopyToClipboard } from "react-copy-to-clipboard";
import htmlToText from "html-to-text";

export default function DocumentItem({ document, citeproc, updated, removed }) {
  const context = useContext(Context);
  const [showDetail, setShowDetail] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  if (!document) return null;

  const lang = document.language || "fa";
  const isFarsi = lang === "fa";
  const direction = isFarsi ? "rtl" : "ltr";
  const textAlign = isFarsi ? "right" : "left";

  const removeItem = () => {
    context.showConfirmationModal(
      "حذف سند",
      "آیا از حذف این سند اطمینان دارید؟",
      [
        { label: "بله", onClick: removed, variant: "danger" },
        { label: "خیر", onClick: () => {} },
      ],
    );
  };

  return (
    <ListGroup.Item style={{ direction, textAlign, position: "relative" }}>
      <div className="results">
        <div
          style={{
            direction,
            textAlign,
            marginLeft: isFarsi ? 30 : 0,
          }}>
          {renderHTML(citeproc.bibliography)}
        </div>
      </div>

      <Dropdown
        align="end"
        style={{
          position: "absolute",
          top: 4,
          left: 4,
        }}>
        <Dropdown.Toggle variant="light" size="sm">
          <i className="fa fa-bars" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setShowDetail(true)}>
            مشاهده جزئیات
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setShowEdit(true)}>
            ویرایش
          </Dropdown.Item>
          <CopyToClipboard
            text={htmlToText.fromString(citeproc.bibliography, {
              wordwrap: false,
            })}>
            <Dropdown.Item>کپی</Dropdown.Item>
          </CopyToClipboard>
          <Dropdown.Item onClick={removeItem}>حذف</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Modal
        show={showDetail}
        style={{ zIndex: 9999 }}
        className="csl-modal"
        onHide={() => setShowDetail(false)}
        size="lg">
        <Modal.Header>
          <Modal.Title>مشاهده جزئیات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="gy-3">
            <Col md={12} style={{ fontWeight: "bold" }}>
              استناد درون‌متن:
            </Col>
            <Col md={12}>{renderHTML(citeproc.citation)}</Col>
            <Col md={12} style={{ fontWeight: "bold" }}>
              استناد برون‌متن:
            </Col>
            <Col md={12}>{renderHTML(citeproc.bibliography)}</Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowDetail(false)}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>

      <EditDocument
        document={document}
        updated={updated}
        show={showEdit}
        set_show={setShowEdit}
      />
    </ListGroup.Item>
  );
}
